<template>
    <div class="m-addFiscanByAuto">
        <h3 class="auto-title">自动组卷设置</h3>

        <div class="auto-main">
            <el-form
                ref="autoForm"
                class="auto-form"
                :model="autoForm"
                :rules="rules"
                label-width="160px"
            >
                <el-form-item label="题目数量" prop="topicCount">
                    <el-input-number v-model="autoForm.topicCount" controls-position="right" :precision="0" :min="0"
                                     :max="200" size="medium"/>
                </el-form-item>

                <el-form-item label="每题分数" prop="topicScore">
                    <el-input-number v-model="autoForm.topicScore" controls-position="right" :min="1" :max="200"
                                     size="medium"/>
                </el-form-item>

                <el-form-item label="设备型号" prop="products">
                    <el-checkbox-group v-model="autoForm.products" @change="getStock">
                        <el-checkbox :label="item.id" v-for="item in fiscanProductDropdown" :key="item.id">{{
                                item.value
                            }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="违禁品数量" prop="tipCounts">
                    <el-checkbox-group v-model="autoForm.tipCounts" @change="getStock">
                        <el-checkbox :label="1">1</el-checkbox>
                        <el-checkbox :label="2">2</el-checkbox>
                        <el-checkbox :label="3">3</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item class="form-danger" prop="knowledges">
                    <template #label>
                        <tip-label tip="违禁品包含的知识点，不选则在全部知识点中随机出题" label="违禁品知识点"/>
                    </template>
                    <el-checkbox-group v-model="autoForm.knowledges">
                        <div class="danger-category" v-for="item in imageDictionary" :key="item.id">
                            <h5>{{ item.name }}</h5>
                            <div class="danger-items">
                                <el-checkbox v-for="v in item.children" :label="v.id" :key="v.id" :disabled="!v.size">
                                    {{ v.name }}
                                    <span class="stock">({{ v.size }})</span>
                                </el-checkbox>
                            </div>
                        </div>

                        <p v-if="!imageDictionary.length" class="no-knowledge">无可用知识点，请调整组卷设置</p>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>

            <transition enter-active-class="animated fadeInDown">
                <div class="show-info" v-if="autoForm.topicCount && autoForm.topicScore">
                    <p>总题数<b>{{ autoForm.topicCount }}</b>道</p>
                    <p>考卷分数<b>{{ autoForm.topicCount * autoForm.topicScore }}</b>分</p>
                    <p>及格分数<b>{{ (autoForm.topicCount * autoForm.topicScore * formData.passLine).toFixed(1) }}</b>分</p>
                </div>
            </transition>

            <div class="btn-wrap">
                <el-button @click="submitPaper" type="primary" :loading="submitLoading">{{ $t('paper.savePaper') }}
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'AddFiscanByAuto',

    props: {
        formData: {
            type: Object
        }
    },

    components: {},

    data() {
        return {
            autoForm: {
                topicCount: null,
                topicScore: 2,
                products: [],
                tipCounts: [],
                knowledges: []
            },
            rules: {
                topicCount: [
                    {required: true, message: '请输入题目数量', trigger: ['change', 'blur']},
                    {pattern: /[^0]/, message: '请输入题目数量', trigger: ['change', 'blur']}
                ],
                topicScore: [
                    {required: true, message: '请输入每题分数', trigger: 'change'}
                ],
                // products: [
                //     {required: true, message: '请选择设备型号', trigger: 'change'}
                // ],
                // tipCounts: [
                //     {required: true, message: '请选择违禁品数量', trigger: 'change'}
                // ],
            },
            imageDictionary: [],
            fiscanProductDropdown: [],
            submitLoading: false
        }
    },

    mounted() {
        this.getStock()

        this.$api.getFiscanProduct().then(res => {
            this.fiscanProductDropdown = res.package
        })
    },

    methods: {
        submitPaper() {
            this.$refs['autoForm'].validate((valid) => {
                if (!valid) return

                const knowledgeArr = this.formData.knowledge

                let submitData = {
                    ...this.formData,
                    knowledge: knowledgeArr[knowledgeArr.length - 1],
                    ...this.autoForm
                }

                this.submitLoading = true

                this.$api.postAutoFiscanPaper(submitData).then(res => {
                    this.submitSuccess()
                }).finally(() => this.submitLoading = false)
            })
        },

        submitSuccess() {
            this.$notify.success({
                title: this.$t('c.success'),
                message: '职鉴考卷制作成功！',
                type: 'success',
                duration: 2000
            })
            this.$emit('needUpdate')
            this.$router.replace({name: 'myPaper'})
        },

        getStock() {
            let data = {
                products: this.autoForm.products,
                tipCounts: this.autoForm.tipCounts,
                hideNodeIfZero: true  // 是否隐藏无库存知识点
            }

            this.$api.getFiscanImageStock(data).then(res => {
                this.imageDictionary = res.package
                this.removeEmptyKnowledgeSelected(this.imageDictionary)
            })
        },

        // 在选中的知识点中，过滤掉库存为0的知识点
        removeEmptyKnowledgeSelected(data) {
            if (!this.autoForm.knowledges.length) return

            // 拍平所有知识点
            this.allKnowledgeFlat = []
            data.forEach(item => {
                this.allKnowledgeFlat = this.allKnowledgeFlat.concat(item.children)
            })

            // 过滤
            let finalKnowledges = []
            this.autoForm.knowledges.forEach(id => {
                let item = this.allKnowledgeFlat.find(v => v.id === id)
                if (item && item.size !== 0) {
                    finalKnowledges.push(id)
                }
            })

            this.autoForm.knowledges = finalKnowledges
        },
    },
}
</script>

<style lang="scss">
.m-addFiscanByAuto {
    padding-top: 10px;

    .el-form-item__label {
        padding-right: 15px;
    }

    .auto-title {
        padding: 2px 10px;
        border-left: 4px solid $blue;
        font-weight: 600;
    }

    .auto-main {
        padding-top: 20px;
        padding-left: 20px;
    }

    .show-info {
        display: flex;
        padding: 12px 20px;
        border-left: 5px solid $blue;
        background-color: lighten($blue, 40%);

        p {
            margin-right: 20px;
        }

        b {
            padding: 0 2px;
            color: $blue;
        }
    }

    .danger-category {
        h5 {
            color: #666;
            font-size: 12px;
        }

        .stock {
            font-size: 12px;
            color: #999;
        }
    }

    .no-knowledge {
        font-size: 12px;
        color: #999;
    }

    .btn-wrap {
        margin-top: 50px;
        text-align: center;

        button {
            padding: 12px 50px;
        }
    }
}
</style>
